import { computed, ComputedRef } from 'vue';
import store from '@/store';
import { State } from '@/types/State';

/**
 * Composable for accessing Vuex store with type safety
 * Replacement for @Getter decorator pattern used in class components
 */
export function useStore() {
  return {
    // Direct store access
    store,

    // State access
    state: store.state as State,

    // Dispatch actions
    dispatch: store.dispatch.bind(store),

    // Commit mutations
    commit: store.commit.bind(store),

    // Helper to create computed getter
    useGetter: <T>(getterName: string, param?: any): ComputedRef<T> => {
      return computed(() => {
        // Existence, not truthiness: a getter whose value is false, 0 or ''
        // is perfectly valid. Testing truthiness made every falsy getter
        // report as missing and return null — so a boolean getter read as
        // null rather than false, and logged a spurious warning each time.
        if (getterName in store.getters) {
          return param !== undefined
            ? store.getters[getterName](param)
            : store.getters[getterName];
        }
        console.warn(`Getter ${getterName} not found in store.`);
        return null;
      });
    },
  };
}
